import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { useUncontrolled } from '../../../hooks/useUncontrolled.js';
import { classnames } from '../../../utils/classnames.js';
import './Textarea.scss.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Textarea = function Textarea(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$autoResize = _a.autoResize,
      autoResize = _a$autoResize === void 0 ? false : _a$autoResize,
      _a$initialRowCount = _a.initialRowCount,
      initialRowCount = _a$initialRowCount === void 0 ? 3 : _a$initialRowCount,
      _a$debounce = _a.debounce,
      debounce = _a$debounce === void 0 ? 300 : _a$debounce,
      getValue = _a.getValue,
      disabled = _a.disabled,
      invalid = _a.invalid,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      _a$onDebounce = _a.onDebounce,
      onDebounce = _a$onDebounce === void 0 ? function () {} : _a$onDebounce,
      onClear = _a.onClear,
      valueProp = _a.value,
      defaultValueProp = _a.defaultValue,
      onChange = _a.onChange,
      props = __rest(_a, ["className", "autoResize", "initialRowCount", "debounce", "getValue", "disabled", "invalid", "onFocus", "onBlur", "onDebounce", "onClear", "value", "defaultValue", "onChange"]);
  /** Ссылка на поле */


  var textarea = useRef(null);
  /** Находится ли инпут в состоянии фокуса */

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var _useUncontrolled = useUncontrolled({
    value: valueProp,
    defaultValue: defaultValueProp,
    finalValue: ''
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      value = _useUncontrolled2[0],
      setValue = _useUncontrolled2[1];

  var handleChange = function handleChange(e) {
    setValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };

  useEffect(function () {
    /** Подписываемся на ввод текста */
    var sub;

    if (textarea.current) {
      sub = fromEvent(textarea.current, 'keyup').pipe(map(function (e) {
        return e;
      }), debounceTime(debounce), distinctUntilChanged()).subscribe(function (e) {
        if (textarea.current) {
          getValue === null || getValue === void 0 ? void 0 : getValue(textarea.current.value);
        }

        onDebounce === null || onDebounce === void 0 ? void 0 : onDebounce(e);
      });
    }

    return function () {
      try {
        sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    };
  }, [props.maxLength, autoResize, onDebounce, debounce]); // ------------------------------------------------------------------------------------------------------------------

  var onInputFocus = function onInputFocus(event) {
    setFocused(true);

    if (onFocus) {
      onFocus(event);
    }
  };

  var onInputBlur = function onInputBlur(event) {
    setFocused(false);

    if (onBlur) {
      onBlur(event);
    }
  }; // ------------------------------------------------------------------------------------------------------------------

  /** @deprecated
   * Очистка поля ввода */


  var clearInput = function clearInput() {
    if (textarea.current) {
      textarea.current.value = '';
      setValue('');
      onClear && onClear();
    }
  };
  /** @deprecated
   * Кнопка сброса */


  var closeButton = onClear && value.length > 0 && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "rf-textarea__action",
    onClick: clearInput,
    "aria-label": "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(AllClose, {
    "data-v-6e52f9c7": ""
  })); // ------------------------------------------------------------------------------------------------------------------
  // Делаем проверку на className для обратной совместимости.

  var isInvalid = invalid || className && className.indexOf('invalid') !== -1;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-textarea ".concat(className),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-textarea__wrapper', disabled && 'rf-textarea__wrapper--disabled', disabled && value.length === 0 && 'rf-textarea__wrapper--no-value', isFocused && 'rf-textarea__wrapper--focused', isInvalid && 'rf-textarea__wrapper--invalid', autoResize && 'rf-textarea__wrapper--auto-resize', !autoResize && 'rf-textarea--scroll', onClear && value.length > 0 && 'rf-textarea--clearable'),
    "data-replicated-value": value,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("textarea", _extends({}, props, {
    disabled: disabled,
    ref: textarea,
    rows: initialRowCount,
    className: classnames('rf-textarea__field', !autoResize && 'rf-textarea--scroll', disabled && value.length === 0 && 'rf-textarea__field--no-value'),
    autoComplete: "off",
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    value: value,
    onChange: handleChange,
    "data-v-6e52f9c7": ""
  })), closeButton));
};

export { Textarea as default };
